import { render, staticRenderFns } from "./speaker-section-card.vue?vue&type=template&id=37dca4e3&scoped=true&"
import script from "./speaker-section-card.vue?vue&type=script&lang=js&"
export * from "./speaker-section-card.vue?vue&type=script&lang=js&"
import style0 from "./speaker-section-card.vue?vue&type=style&index=0&id=37dca4e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dca4e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37dca4e3')) {
      api.createRecord('37dca4e3', component.options)
    } else {
      api.reload('37dca4e3', component.options)
    }
    module.hot.accept("./speaker-section-card.vue?vue&type=template&id=37dca4e3&scoped=true&", function () {
      api.rerender('37dca4e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/speaker-section-card.vue"
export default component.exports